//import SignUpSuccess from "./SignUpSuccess/SignUpSuccess";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import appActions from "Actions/appActions";
// import localeInitActions from "Actions/localeActions/localeInitActions";
import userActions from "Actions/userActions";
import LoginToken from './LoginToken';

const mapStateToProps = state => {
  return {
    account: state.form.account.values,
    country: state.locale.country,
    language: state.locale.language,
    locale: state.locale.locale,
    loginToken : state.user.token,
    authStatus : state.user.authStatus,
    membershipID: state.user.data.id.unicity,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatchIsLoading : isLoading => dispatch(appActions.setIsLoading(isLoading)),
    getLoginToken : () => dispatch(userActions.getAuthToken()),
    renewLoginToken : (token) => {
      if(!token) return;
      dispatch(userActions.renewAuthToken(token))
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginToken));



// WEBPACK FOOTER //
// ./src/components/SignUpSuccessContainer/SignUpSuccessContainer.js